interface TierOption<T extends string | number> {
  value: T;
  label: string;
}

interface TierSelectorProps<T extends string | number> {
  options: TierOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

export function TierSelector<T extends string | number>({
  options,
  value,
  onChange,
}: TierSelectorProps<T>) {
  const activeIndex = Math.max(
    0,
    options.findIndex((option) => option.value === value)
  );
  const segmentWidthPercent = 100 / Math.max(options.length, 1);

  return (
    <div className="w-full">
      <div className="flex text-sm font-semibold text-text-secondary">
        {options.map((option) => {
          const isActive = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`flex-1 pb-2 text-center transition-colors ${
                isActive ? 'text-white' : 'text-text-secondary hover:text-text-primary'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      <div className="relative h-0.5 bg-gray-700 rounded-full overflow-hidden">
        <span
          className="absolute inset-y-0 bg-accent transition-all duration-300"
          style={{
            width: `${segmentWidthPercent}%`,
            left: `${activeIndex * segmentWidthPercent}%`,
          }}
        />
      </div>
    </div>
  );
}

